import { useQuery } from '@tanstack/react-query';

import portService from '~/services/cruises/PortService';

import { portPOIQueryKeys } from './portPOIQueryKeys';

export function useGetPortPOIs(portId: string) {
  return useQuery({
    queryKey: portPOIQueryKeys.detail(portId),
    queryFn: ({ signal }) => portService.getPortPOIs(portId, signal),
    enabled: !!portId,
  });
}
